@import '../../../global/component.css';

.hero-background::after {
    background-image: url(/assets/spy-master.webp);
    background-position: center 35%;
}

.diagram {
    margin: 0 -1.5rem;
    font-size: .7rem;
}

.existing:not(text) {
    filter: brightness(.9) grayscale(.667);
}

.version-2 {
    text-decoration: line-through;
}

.label {
    paint-order: stroke;
}

.label.out {
    fill: currentColor;
    stroke: var(--background-color);
    stroke-width: 3px;
}